import 'Styles/forumview.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import forumViewSelector from 'Selectors/forumViewSelector';
import { fetchForum, resetForum } from 'Actions/ForumviewActions';
import { checkAdsPermissions, resetHiddenAdsPerUser, trackPageView, onPageView } from 'Actions/adsActions';
import ForumList from 'Components/forums/ForumListComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

import rawToReact from 'Utils/bbcode/RawToReact';
import AdComponent from 'Components/ads/AdComponent';


class ForumsIndexViewComponent extends React.Component {
	componentWillMount() {
		this.props.dispatch( resetForum() );
	}

	componentDidMount() {
		// is this index the landing page per config?
		let thisIsIndex = ( process.env.config.IndexRoute === 'index' && process.env.config.section.home === false );

		if(
			thisIsIndex &&
			this.props.firstLoad &&
			(
				this.props.initialRoute ||
				this.props.userSettings.landingPage !== 'index'
			)
		) {
			return;
		}

		window.scrollTo(0, 0);
		this.props.dispatch(fetchForum({
			id: -1,
			size: 10,
			page: 1,
			forceRefresh: true
		}));
	}

	componentWillUnmount() {
		this.props.dispatch( resetForum() );
	}

	componentWillReceiveProps(nextProps) {
		if( nextProps.forumview.forumId ) {
			this.props.dispatch( checkAdsPermissions( -1 ) );
			this.props.dispatch( resetHiddenAdsPerUser() );
		}

		if( nextProps.forumview.loaded && nextProps.forumview.loaded !== this.props.forumview.loaded ) {
			window.scrollTo(0, 0);

			// trigger ad updates
			this.props.dispatch( onPageView( { captify: "" } ) );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	groupForums = () => {
		let {entities: {forums}, result} = this.props.forumview;
		let structure = {};
		let displayOrder = [];

		result.forums.forEach(
			(v) => {
				let forum = forums[v];
				if( parseInt( forum.parent ) !== -1 ) {
					if (!structure[forum.parent]) {
						structure[forum.parent] = [];
					}
					structure[forum.parent].push(forum.id);
				} else {
					displayOrder.push(v);
				}
			}
		);

		return displayOrder
			.filter(t => structure[t] !== undefined) // API sends missing data sometimes.
			.map(
				(v, i) => {
					let adUnit = i === 1 ? <AdComponent adType="5" fallbackAdType={ [1] } adName={ 'In_Content_Ad' } /> : null,
						adUnitIncontent = ( i === 0 ); // first category

					let forumGroup = [
						<div key={ `forumgroup${i}` }>
							<div className="forumGroup nolinks">
								{ rawToReact(forums[v].title) }
							</div>
							<ForumList forumList={ structure[v] } adUnitIncontent={ adUnitIncontent } />
						</div>
					];
					if( adUnit ) {
						forumGroup.push( adUnit );
					}

					return forumGroup;
				}
			);
	};

	render() {
		const {forumSite} = this.props;
		const lists = this.props.forumview.loaded ? this.groupForums() : <LoaderCss />;

		return (
			<div className="forumRoot" >
				<div className="coverphoto">
					<img className="no-ad" src={forumSite.cover_photo} />
				</div>
				<div className="detail nolinks nooptimize norewrite">
					<div className="title">
						{forumSite.f_title}
					</div>
					<div className="url">
						{forumSite.f_url}
					</div>
				</div>
				{ lists }
				<AdComponent adType="2" adName="Bottom_Content_Rectangle"  isFetching={ this.props.forumview.isFetching } />
			</div>
		);
	}
}

ForumsIndexViewComponent.propTypes = {
	forumSite: PropTypes.shape({
		cover_photo: PropTypes.string.isRequired,
		f_title: PropTypes.string.isRequired,
		f_url: PropTypes.string.isRequired
	})
};

export default connect( forumViewSelector )( ForumsIndexViewComponent );



// WEBPACK FOOTER //
// ./src/components/ForumsIndexViewComponent.js